import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "replace"})
export class Replace implements PipeTransform {
  constructor() {
  }
  transform(value: string, regexValue: string, replaceValue: string): any {
    return value.toString().replace(regexValue, replaceValue);
  }
}




// WEBPACK FOOTER //
// ./src/pipes/replace.ts